export const Constants = {
  barHeight: 70,
  logoHeight: 23,
  logoWidth: 118,
  searchBarWidth: 244,
  verticalSpacingMd: 42,
};
